import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundaryFallback from './components/ErrorBoundaryFallback';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);

reportWebVitals();
